<script lang="ts">
    import type { IconGraphicProps } from '../../foundations/iconography.js'

    let { class: className, ...svgAttributes }: IconGraphicProps = $props()
</script>

<svg
    {...svgAttributes}
    class={className}
    fill="none"
    viewBox="0 0 15.9639 9.91845"
    xmlns="http://www.w3.org/2000/svg"
>
<path id="Vector" d="M8.04541 0C8.51208 0 8.91208 0.2 9.17874 0.533333L15.6454 7.86667C16.1121 8.33333 16.0454 9.13333 15.5787 9.6C15.1121 10.0667 14.3121 10 13.8454 9.53333C13.8454 9.53333 13.8454 9.53333 13.7787 9.46667L8.11208 3.06667C8.04541 3 7.97874 3 7.84541 3.06667L2.17874 9.46667C1.71208 10 0.978742 10.0667 0.445408 9.6C-0.087925 9.13333 -0.154592 8.4 0.312075 7.86667C0.312075 7.86667 0.312075 7.86667 0.378742 7.8L6.84541 0.466667C7.17874 0.2 7.57874 0 8.04541 0Z" fill="var(--fill-0, #393939)"/>
</svg>
